import './blog.css'

import { Link, useI18next } from 'gatsby-plugin-react-i18next'
import React, { ReactNode } from 'react'

import Close from '../../svg/Close'
import Footer from './Footer'
import { Navbar } from '../Navbar/Navbar'

type LayoutProps = {
    children: ReactNode
    hasFooter?: boolean
    title?: string | null
    linkBack: string
}

export const LayoutBlogIndex = ({ children, linkBack, title }: LayoutProps) => {
    useI18next()
    return (
        <main>
            <title>{title}</title>

            <div className="min-h-screen min-w-screen max-w-screen overflow-x-hidden">
                <div className="max-w-screen-2xl relative mx-auto flex-grow  justify-between flex flex-col h-screen">
                    <Navbar />
                    <div className="max-w-screen-lg 2xl:max-w-screen-xl relative mx-auto min-w-full">
                        {title !== 'Blog' && (
                            <div className="w-full place-content-end flex p-2">
                                <Link
                                    to={linkBack}
                                    className="cursor-pointer text-neutral-900 hover:underline font-semibold"
                                >
                                    Go back to the previous page
                                </Link>
                            </div>
                        )}
                        <div className="max-w-screen-xl relative mx-auto space-y-7 font-mono text-justify px-8">
                            {children}
                        </div>

                        {title !== 'Blog' && (
                            <div className="w-full place-content-end flex p-2">
                                <Link
                                    to={linkBack}
                                    className="cursor-pointer text-neutral-900 hover:underline font-semibold"
                                >
                                    Go back to the previous page
                                </Link>
                            </div>
                        )}
                    </div>
                    <Footer />
                </div>
            </div>
        </main>
    )
}
